import { render, staticRenderFns } from "./sceneEffect.vue?vue&type=template&id=2676ec3d&scoped=true"
import script from "./sceneEffect.vue?vue&type=script&lang=js"
export * from "./sceneEffect.vue?vue&type=script&lang=js"
import style0 from "./sceneEffect.vue?vue&type=style&index=0&id=2676ec3d&scoped=true&lang=css"
import style1 from "./sceneEffect.vue?vue&type=style&index=1&id=2676ec3d&lang=css"
import style2 from "./sceneEffect.vue?vue&type=style&index=2&id=2676ec3d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676ec3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2676ec3d')) {
      api.createRecord('2676ec3d', component.options)
    } else {
      api.reload('2676ec3d', component.options)
    }
    module.hot.accept("./sceneEffect.vue?vue&type=template&id=2676ec3d&scoped=true", function () {
      api.rerender('2676ec3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/neewerhome/sceneEffect.vue"
export default component.exports